export function LobuMark({ className }: { className?: string }) {
	return (
		<svg
			viewBox="-8 -7.3 116 116"
			className={className}
			fill="currentColor"
			aria-hidden="true"
			data-lobu-mark=""
		>
			<rect x="0" y="0.5" width="45" height="100" />
			<circle cx="77" cy="23" r="23" />
			<path d="M55,55.96h45v22.5c0,12.42-10.08,22.5-22.5,22.5h0c-12.42,0-22.5-10.08-22.5-22.5v-22.5h0Z" />
		</svg>
	);
}
